<template>
	<v-app dark>
		<v-toolbar app fixed clipped-left>
			<v-toolbar-title>Srđan Nikolić</v-toolbar-title>
		</v-toolbar>
		<v-content>
			<resume></resume>
		</v-content>
	</v-app>
</template>

<script>
	import Resume from "./components/Resume"

	export default {
		name: 'App',
		components: {Resume},
		data() {
			return {}
		}
	}
</script>
